// investigation
export const INVESTIGATION_FETCH_SORT_PARAM = 'INVESTIGATION_FETCH_SORT_PARAM';

// execute
export const SEARCH_PARAMS_SET = 'SEARCH_PARAMS_SET';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';

//set staffInfo
export const STAFF_INFO = 'STAFF_INFO';

//template
export const SAVE_TEMPLATE_LIST = 'SAVE_TEMPLATE_LIST';
export const SAVE_TEMPLATE_ITEM = 'SAVE_TEMPLATE_ITEM';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js